import { render } from "./ssq-list.vue?vue&type=template&id=77809ebd&scoped=true"
import script from "./ssq-list.vue?vue&type=script&lang=js"
export * from "./ssq-list.vue?vue&type=script&lang=js"

import "./ssq-list.vue?vue&type=style&index=0&id=77809ebd&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77809ebd"]])

export default __exports__